import React from 'react';

const SITE_NAME = 'Tennis de Table Briançon';
const BASE_URL = 'https://www.ttbriancon.fr';
const DEFAULT_IMAGE = `${BASE_URL}/img/og.jpg`;

/**
 * Métadonnées par page. React 19 hoiste nativement <title>/<meta>/<link>
 * dans le <head>, et react-snap les fige dans le HTML pré-rendu.
 */
function Seo({ title, description, path = '/', image = DEFAULT_IMAGE, noindex = false }) {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} - Site Officiel`;
  const url = `${BASE_URL}${path}`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, follow" />}

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </>
  );
}

export default Seo;
